
import { IScrBaseResponse, MbOptOutResponse} from "src/app/services";


export interface MbEvent {
  isCompleted: boolean;
}


export interface MbOptOutUpdateEvent extends MbEvent {
  response?: MbOptOutResponse;
 
    type?: string;
    //response?: ScrBaseResponse;
    scId?: number;
  }




export interface MbOptOutSuccessUpdateEvent extends MbEvent {
  response?: IScrBaseResponse;
}

  export function handleEnterKeyPress(event: Event){
    if(event.target){
      const tagName = (event.target as HTMLElement).tagName.toLowerCase();
      if(tagName === 'textarea'){
        return true;
      }
    }
      return event.preventDefault();
  }